import React from 'react';
import visa from 'assets/images/visa.svg';
import { SvgIconProps } from '@mui/material';

export const AfVisaIcon: React.FC<SvgIconProps> = () => {
  return <img src={visa} />;
};
